// extracted by mini-css-extract-plugin
module.exports = {"section":"Sect3_Comp1_section__3fq8K","content":"Sect3_Comp1_content__2Ep7j","lightbox":"Sect3_Comp1_lightbox__1_g-_"};